import {
  IconExcel,
  IconImage,
  IconPpt,
  IconPdf,
  IconTxt,
  IconVideo,
  IconWord,
  IconOthers
} from "@/components/Icon";

export default function getFileIcon(fileName) {
  if (!fileName) {
    return IconOthers;
  }
  if (/\.(png|jpe?g|gif|webp|svg|bmp|heic|jfif)$/i.test(fileName)) {
    return IconImage;
  }
  if (/\.(doc|docx|dotx)$/i.test(fileName)) {
    return IconWord;
  }
  if (/\.(ppt|pptx|pptm)$/i.test(fileName)) {
    return IconPpt;
  }
  if (/\.(pdf)$/i.test(fileName)) {
    return IconPdf;
  }
  if (/\.(xlsx|xlsm|xlsb|xltx|xls|xlt)$/i.test(fileName)) {
    return IconExcel;
  }
  if (/\.(mov|mp4|ogg|webm)$/i.test(fileName)) {
    return IconVideo;
  }
  // TODO 暂无音乐图标
  if (/\.(mp3|flac|ape|m4a|wav)$/i.test(fileName)) {
    return IconOthers;
  }
  if (/\.(txt)$/i.test(fileName)) {
    return IconTxt;
  }
  return IconOthers;
}
